import React from 'react';

import Plot from '../Plot';
import PieChart from '../PieChart';

// TODO: Include scale if using colour scale
function DoughnutPlot({ size, sensors, maxValue, makeColors }) {
  return (
    <Plot size={size}>
      {({ xScale, yScale }) => sensors.map(sensor => (
        <PieChart
          key={sensor.lsid}
          x={xScale(sensor.x)}
          y={yScale(sensor.y)}
          value={sensor.value}
          max={maxValue}
          units="%"
          colors={makeColors(sensor.value)}
        />
      ))}
    </Plot>
  )
}

DoughnutPlot.defaultProps = {
  offset: {
    x: 0,
    y: 0,
  },
  makeColors: () => [
    'green',
    'red',
  ],
}

export default DoughnutPlot;



// WEBPACK FOOTER //
// ./src/components/DoughnutPlot/DoughnutPlot.component.js